import { Component, EventEmitter, Input, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';
import { News } from 'src/typings';
import { environment } from 'src/environments/environment';
import { NewsService } from '../news.service';

@Component({
  selector: 'app-news-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() news: News | undefined;
  @Output() deleted = new EventEmitter<number>();
  deleting = false;

  constructor(
    private newsService: NewsService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  get img() {
    return `${environment.BACKEND}/image/${this.news?.img}`;
  }

  update() {
    if (!this.news) return this.notificationService.warning('Нет новости для редактирования!');
    this.router.navigate(['/news', this.news.id, 'edit']);
  }

  async delete() {
    if (!this.news) return this.notificationService.warning('Нет новости для удаления!');
    if (this.deleting || !window.confirm('Удалить новость?')) return;
    this.deleting = true;
    try {
      await firstValueFrom(this.newsService.delete(this.news.id));
      this.deleted.emit(this.news.id);
    } catch {
      this.notificationService.showError('Не удалось удалить новость');
    } finally {
      this.deleting = false;
    }
  }
}
